/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Pull_Business_ToolsInputs */



/**
* | output |
* | --- |
* | "Which business tools can I connect?" |
*
* @param {Uno_Welcome_Suggestion_Pull_Business_ToolsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_pull_business_tools = /** @type {((inputs?: Uno_Welcome_Suggestion_Pull_Business_ToolsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Pull_Business_ToolsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Welche Business-Tools kann ich verbinden?")
	return /** @type {LocalizedString} */ ("Which business tools can I connect?")
});